

import React, {PureComponent, Children} from 'react'
import {If, Then} from 'react-if'
import {EVERY} from '../../../data/constants'
import head from 'lodash/head'
import {getValues} from '../../../utils'
import Select from '../Select'
import {DayOfWeek, DayOfMonth, Month} from './index'

export default class DateComponent extends PureComponent {
    static defaultProps = {
        children: null
    };

    state = {
        activeComponent: DayOfWeek.className
    };

    setActiveComponent = ({target: {value}}) => {
        this.setState({
            activeComponent: value
        })
        
    };

    onChange = (onChange) => {
        return (value) => {
            const values = getValues(value);
            const first = head(values);
            if(first === EVERY && values.length > 1) {
                onChange(values.filter((val) => val !== EVERY))
            } else {
                const everyIndex = values.indexOf(EVERY);
                if(everyIndex !== -1) {
                    onChange([EVERY])
                } else {
                    onChange(values)
                }
            }
        }
    };

    render() {
        const {styleNameFactory, children} = this.props;
        const {activeComponent} = this.state;
        return (
            <div
               style={{display: 'flex', flexDirection: 'column'}}
            >
                <div>
                <div {...styleNameFactory('label')} >
                    On:
                </div>
                <div {...styleNameFactory('row', 'items-end')} >
                    {Children.map(children, (child) => {
                        const {value, onChange} = child.props;
                        const {getOptions} = child.type;
                        return (
                            <If condition={child.type.className === activeComponent} >
                                <Then>
                                    <div
                                        {...styleNameFactory('input')}
                                    >
                                        <Select
                                            style={{minWidth: 120}}
                                            value={value}
                                            options={getOptions()}
                                            multi
                                            autosize
                                            onChange={this.onChange(onChange)}
                                        />
                                    </div>
                                </Then>
                            </If>
                        )
                    })}
                    </div>
                </div>
                <div
                    {...styleNameFactory('link')}
                >
                    <select onChange={this.setActiveComponent} style={{padding: "4px 7px", borderRadius:"6px", background: "white", textTransform:"capitalize", fontSize: "1em", border: "2px solid #d9d9d9", width: "100%", color:"#373c51"}} >
                        <option value={DayOfWeek.className}>day of week</option>
                        <option value={DayOfMonth.className}>day of month</option>
                        <option value={Month.className}>month</option>
                    </select>
                </div>
                
            </div>
        )
    }
}
